var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeEvery } from "redux-saga/effects";
import { GET_COMPANY_INFO_REQUEST, getCompanyInfoSuccess, getCompanyInfoFailure } from "../../actions";
import API from "@/utils/API";
// onboarding-service guards every /internal/** route with this header (see SecretKeyFilter)
const INTERNAL_SECRET = "h74rrDK+RcsDDFyhi5957HRimJAMz/VrDj9bujs7Qo+l0annIrLNImdxEtkN45cM";
const onGetCompanyInfo = (companyIds) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // Axios's default array serialization adds `[]` to the key (companyIds[]=...), which
            // this endpoint's Spring @RequestParam List<String> binding does not accept — so the
            // repeated-key query string is built manually instead of passed via `params`.
            const query = companyIds.map((id) => `companyIds=${encodeURIComponent(id)}`).join("&");
            API.get(`/onbd/internal/company/info?${query}`, undefined, { "X-ZIPPYY-SECRET": INTERNAL_SECRET })
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getCompanyInfoWorker(action) {
    var _a, _b, _c;
    const companyIds = action.payload.companyIds;
    try {
        const data = yield call(onGetCompanyInfo, companyIds);
        yield put(getCompanyInfoSuccess({ data }));
    }
    catch (error) {
        yield put(getCompanyInfoFailure({ companyIds, error: ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.messages) === null || _c === void 0 ? void 0 : _c[0]) || (error === null || error === void 0 ? void 0 : error.message) }));
    }
}
export function* watchGetCompanyInfo() {
    yield takeEvery(GET_COMPANY_INFO_REQUEST, getCompanyInfoWorker);
}
